export const HOME            = '/'
export const ACCOUNT         = '/account'
export const ALMOST          = '/almost'
export const BROWSE          = '/browse'
export const GENRE           = '/browse/genre/:id'
export const CONFIRM         = '/confirm'
export const FORGOT_PASSWORD = '/forgot-password'
export const LOGIN           = '/login'
export const NOTFOUND        = '/notfound'
export const SIGNUP          = '/signup'
export const TITLE           = '/title/:id'
export const WATCH           = '/watch/:id'


// WEBPACK FOOTER //
// ./src/common/constants/path-names.js